module.exports = __webpack_public_path__ + "img/Sudeste.01fe2d8f.png";